import React from 'react';
import cx from 'classnames';

import { Link } from 'gatsby';
import logoWhite from '../../../static/logo-full-white.svg';
import logoColor from '../../../static/logo-full-color.svg';

import nav from '../../lib/nav';
import { setLocale } from '../../lib/localeStore';

import styles from './index.module.scss';

const leftNav = ['admissions', 'the-kingston-difference', 'learning-at-kingston'];
const rightNav = ['life-at-kingston', 'contact-us', 'parent-portal'];

const renderNavItems = (items, locale, maxLayer, currentLayer = 0, prevKeys = []) => (
  <ul className={currentLayer === 0 ? styles.nav : ''}>
    {items.map(item => (
      <li key={item.uri}>
        {item.url ? (
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            {item.text[locale]}
          </a>
        ) : (
          <Link exact to={`/${locale}${item.uri}`}>
            {item.text[locale]}
          </Link>
        )}
        {currentLayer < maxLayer &&
          !!item.items &&
          !!item.items.length &&
          renderNavItems(item.items, locale, maxLayer, currentLayer + 1, [...prevKeys, item.key])}
      </li>
    ))}
  </ul>
);

const createChangeLocaleHandler = (currentLocale, locale) => e => {
  e.preventDefault();

  if (currentLocale === locale) {
    return;
  }

  setLocale(locale);

  const currentUrl = `${window.location}`;
  const url =
    currentUrl.indexOf(`/${currentLocale}/`) > -1
      ? currentUrl.replace(`/${currentLocale}/`, `/${locale}/`)
      : `/${locale}`;
  window.location = url;
};

/* eslint-disable react/prop-types */
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasMounted: false };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  renderLocaleLinks() {
    return (
      <ul key={this.state.hasMounted ? 'mounted' : 'not-mounted'} className={`${styles.nav} ${styles.locale}`}>
        {['en', 'zh'].map(locale => (
          <li key={locale}>
            <a
              href={`/${locale}`}
              className={locale === this.props.locale ? styles.selected : ''}
              onClick={createChangeLocaleHandler(this.props.locale, locale)}
            >
              {locale === 'en' ? 'EN' : '中文'}
            </a>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    const { locale, fixed = false, onToggle } = this.props;

    return (
      <div
        className={cx({
          [styles.root]: true,
          [styles.fixed]: fixed,
        })}
      >
        <div className={styles.logoWrapper}>
          <Link to="/">
            <img className={`${styles.logo} ${styles.white}`} src={logoWhite} alt="Kingston International School" />
            <img className={`${styles.logo} ${styles.color}`} src={logoColor} alt="Kingston International School" />
          </Link>
        </div>

        <div className={`${styles.navWrapper} ${styles.left}`}>
          {renderNavItems(leftNav.map(key => nav.find(m => m.key === key)), locale, 1)}
        </div>
        <div className={`${styles.navWrapper} ${styles.right}`}>
          {renderNavItems(rightNav.map(key => nav.find(m => m.key === key)), locale, 1)}
          {this.renderLocaleLinks()}
        </div>

        <div className={styles.navToggle}>
          <button onClick={onToggle}>
            <span>Toggle Menu</span>
          </button>
        </div>
      </div>
    );
  }
}
